import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

import GyAiIcon from '../icons/GyAiIcon';

// Global AI assistant modal — reachable from the persistent header icon on every
// provider page. Placeholder suggestions for now (not yet wired to a model).
const SUGGESTIONS = [
  {
    title: 'Reactivate sleeping churners',
    text: 'Several clients haven’t visited in 60+ days. A 2-for-1 week pass could win them back — want a draft email?',
  },
  { title: 'Optimize underused services', text: 'Some services sit below 40% utilization. Consider dropping a weekly session or bundling them.' },
  { title: 'Reward loyalty', text: 'Create a referral code for your most engaged clients — loyal referrals retain ~30% better.' },
];

const AiChatModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }} onClick={onClose}>
      <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white shadow-xl" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <GyAiIcon size={20} />
            <h3 className="text-sm font-semibold text-gray-900">AI Assistant Insights</h3>
          </div>
          <button onClick={onClose} className="w-6 h-6 flex items-center justify-center rounded text-gray-500 hover:bg-gray-100" aria-label="Close">
            <CloseIcon style={{ fontSize: 18 }} />
          </button>
        </div>
        <div className="p-5 space-y-3">
          {SUGGESTIONS.map((s, i) => (
            <div key={i} className="rounded-lg border border-gray-200 p-4">
              <p className="text-sm font-semibold mb-1 text-gray-900">{s.title}</p>
              <p className="text-xs text-gray-500">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AiChatModal;
